export default "/assets/2cd6b31a7483998a.svg"